module.exports = __webpack_public_path__ + "static/intersection-e7337fec2c4cd3d4a1c30e1bd6f3e361.jpg";